// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nFw5","toggleWrap":"styles_toggleWrap__3LUko","content":"styles_content__32QSN","selectAreaCode":"styles_selectAreaCode__KZwIR"};